import axios from "axios";
import { SessionStorage } from "./storage";

const baseURL: string | undefined = process.env.REACT_APP_API_BASE_URL;
let isSessionModalVisible = false;

const AjexPortalService = axios.create({
    baseURL: baseURL,
    headers: {
        Accept: 'application/json'
    },
    // signal:AbortSignal.timeout(5000)//500000 - 500 seconds
});

AjexPortalService.interceptors.request.use((config) => {
    const token = SessionStorage.get('token');
    if (token && token?.length) {
        config.headers!.Authorization = `Bearer ${token}`;
    }
    return config;
}
);

AjexPortalService.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401 && !isSessionModalVisible) {
            isSessionModalVisible = true;

            // Dispatch event to show modal in UI
            window.dispatchEvent(new Event("sessionExpired"));

            // Automatically reset flag after 5 seconds (when session clears)
            setTimeout(() => {
                isSessionModalVisible = false;
            }, 5000);
        }
        return Promise.reject(error);
    }
);

export default AjexPortalService;
